// @flow
import React from 'react';
import classnames from 'classnames';

import Image from 'Components/frameworks/image/Image.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ICONS } from 'Components/utils/icon/icons';

import { themes } from './SocialPicture.themes';

export type SocialPictureProps = {
  src: string,
  userName: string,
  className?: string,
  theme?: string,
};

export function SocialPicture(props: SocialPictureProps) {
  const { className, src, theme = 'default', userName } = props;

  if (!src) {
    return null;
  }

  const {
    thIcon,
    thIconColor,
    thIconContainer,
    thIconWidth,
    thImageSize,
    thRoot,
    thText,
    changeWidthButHeightIsAuto,
  } = themes[theme];

  return (
    <div className={classnames(className, thRoot)} data-testid="social-picture">
      <Image
        forceImage
        mandatoryWidthAndHeight={thImageSize}
        transformation="resize"
        imageUrl={src}
        className="align-bottom w-full"
        changeWidthButHeightIsAuto={changeWidthButHeightIsAuto}
      />
      {userName && (
        <div className={thIconContainer}>
          <Icon name={ICONS.INSTAGRAM} className={thIcon} width={thIconWidth} color={thIconColor} />
          <span className={thText}>{userName}</span>
        </div>
      )}
    </div>
  );
}
